import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled, { css } from 'styled-components';
import { borderRadius, color, spacing, typography, sizeAttributes, zIndex, propsBlocker, getComponentOverride, paddingAttributes } from '../../system';
import { popperArrow, popperArrowPlacement } from '../../utils/popper';

var getRootStyle = function getRootStyle(_ref) {
  var displayMenuElements = _ref.displayMenuElements;
  var result = {};

  if (displayMenuElements) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n            padding-top: ", ";\n            padding-bottom: ", ";\n        "])), result, spacing(2), spacing(2));
  }

  return result;
};

export var ContextMenuRoot = styled.div.withConfig(propsBlocker)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    margin: 0;\n    text-align: left;\n\n    ", ";\n    border-radius: ", ";\n    color: ", ";\n    background-color: ", ";\n\n    box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.12);\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), typography('paragraphLarge'), borderRadius('soft'), color('neutral.05'), color('neutral.00'), popperArrowPlacement('ContextMenu-Arrow'), zIndex, getRootStyle, getComponentOverride('ContextMenu'), sizeAttributes, paddingAttributes);
export var ContextMenuArrow = styled.div.withConfig(propsBlocker)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n"])), popperArrow);